<template>
  <div>
    <section
      v-for="service in data"
      :key="service.name"
      class="app-list"
    >
      <h2
        v-if="!service.disabled"
        class="app-list-title"
      >
        {{ service.name }}
      </h2>
      <v-row>
        <v-col
          v-for="item in service.list"
          v-show="item.data?.count > 0"
          :key="item.name"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class="app-list-services__item"
        >
          <div
            :class="
              item.data?.count == 0
                ? 'app-list-services__disabled'
                : 'app-list-services__link'
            "
            :title="item.name"
            style="position: relative"
            @click="item.data?.count == 0 ? '' : openDialog(item, service.name, service.idReceita)"
          >
            <div class="app-list-services__icon-wrapper">
              <v-icon :class="item.data?.count == 0 ? 'icon-disabled' : 'icon'">
                {{ item.icon }}
              </v-icon>
            </div>
            <span class="title">{{ item.name }}</span>
            <span
              v-if="item.data?.count > 0"
              class="title-qtd mt-2"
            >Quantidade: {{ item.data?.count }}
            </span>
          </div>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {
  name: "CardList",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openDialog(item, receitaName, receitaId) {
      this.$emit("open", true);
      this.$emit("itemSelected", {
        ...item,
        nameReceita: receitaName,
        receitaId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  &-list {
    margin-top: 20px;

    &-title {
      color: #333;
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
    }
  }

  &-list-services {
    &__item {
      display: flex;
      justify-content: center;
    }

    &__link {
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      border-radius: 12px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      width: 100%;
      padding: 16px;
      transition: transform 0.2s ease-in-out, background 0.3s ease-in-out;
      cursor: pointer;
      position: relative;

      &:hover {
        background-color: #1976d2;
        transform: scale(1.05);

        .title {
          color: #fff;
        }
      }
    }

    &__disabled {
      background-color: #eeeeee;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      border-radius: 12px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      width: 100%;
      padding: 16px;
      cursor: not-allowed;
      position: relative;
    }

    &__icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #f0f0f0;
      padding: 10px;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }
  }

  .icon {
    color: #1976d2;
    font-size: 28px;
  }

  .icon-disabled {
    color: #747373;
    font-size: 28px;
  }

  .title {
    color: #333;
    font-size: 15px !important;
    font-weight: 500;
    text-align: center;
  }

  .title-qtd {
    color: #176ec5;
    font-size: 11px !important;
    font-weight: 800;
    text-align: center;
    background-color: #ececec;
    padding: 5px 15px 5px 15px;
    border-radius: 10px;
  }
}
</style>
